import { useState } from 'react';

const initialFormState = {
  name: '',
  phone: '',
  email: '',
  message: '',
};

const useContactForm = () => {
  const [formData, setFormData] = useState(initialFormState);
  const [errors, setErrors] = useState({});

  const validate = () => {
    const errs = {};
    if (!formData.name.trim()) {
      errs.name = 'Name is required';
    }

    if (!formData.phone.trim()) {
      errs.phone = 'Phone number is required';
    } else if (!/^\d{10}$/.test(formData.phone)) {
      errs.phone = 'Phone number must be exactly 10 digits';
    }

    return errs;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: '' })); // Clear error on change
  };

  const handleSubmit = (onSuccess) => (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    onSuccess(formData);
    setFormData(initialFormState);
    setErrors({});
  };

  return {
    formData,
    errors,
    handleChange,
    handleSubmit,
  };
};

export default useContactForm;
